module.exports = __webpack_public_path__ + "img/court-gavel-justice-450x300.6ac31e7a.jpg";